import { render } from "./invoice-reports.vue?vue&type=template&id=7b1248b8"
import script from "./invoice-reports.vue?vue&type=script&lang=js"
export * from "./invoice-reports.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__